// @flow
import "core-js/es6/map";
import "core-js/es6/set";
import "core-js/es6/array";

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js